import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BrakeFluidFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.7199 10.32C11.3 10.32 10.0799 11.54 10.0799 12.96C10.0799 14.38 11.3 15.6 12.7199 15.6C14.1399 15.6 15.36 14.38 15.36 12.96C15.36 11.54 14.14 10.32 12.7199 10.32ZM19.6148 12.1941C19.9387 16.8908 16.5199 19.94 12.7199 19.94C8.91996 19.94 5.77995 16.78 5.77995 12.96C5.77995 9.14001 9.59661 4.51288 15.0028 6.38287C15.1529 5.8695 15.4164 5.34716 15.8163 4.76068C13.3833 3.69854 9.02658 3.94284 6.31999 6.94L5.35997 5.98004C1.77899 9.31746 1.20896 15.995 5.35997 19.94L6.31999 18.98C7.93999 20.6801 10.2199 21.7401 12.7199 21.7401C17.54 21.7401 22.1483 17.5505 21.4299 11.6606C20.8778 11.962 20.2655 12.1492 19.6148 12.1941ZM19.3204 10.7841C21.8117 10.7841 24.8247 7.56664 19.3204 2.86621C14.0347 7.21466 16.7628 10.7841 19.3204 10.7841ZM19.3204 5.28522C21.1602 6.82517 21.2823 8.86958 19.3204 9.14411C17.3735 8.78815 17.4142 7.03733 19.3204 5.28522Z" />
    </SvgIcon>
  );
});
